import * as i1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Inject, Input, ViewChild, NgModule } from '@angular/core';
import { debounce, get } from 'lodash-es';
const _c0 = ["tooltipContainer"];
const _c1 = ["tooltipBoxArrow"];
const _c2 = [[["", "tooltip", ""]], [["", "tooltip-box", ""]]];
const _c3 = ["[tooltip]", "[tooltip-box]"];
const _c4 = a0 => ({
  "tooltip-hidden": a0
});
const _c5 = a0 => ({
  "background-color": a0
});
class TooltipComponent {
  constructor(renderer, document) {
    this.renderer = renderer;
    this.document = document;
    this.displayTooltip = debounce(event => this.showTooltip(event), 100, {
      leading: true
    });
  }
  ngOnInit() {
    this.tooltipHidden = true;
  }
  ngAfterViewInit() {
    this.tooltipContent = this.tooltipContainer.nativeElement;
    this.tooltipArrow = this.tooltipBoxArrow.nativeElement;
  }
  showTooltip(event) {
    if (!this.tooltipHidden) {
      return;
    }
    this.removeClass();
    this.positionTootip(event);
    this.tooltipHidden = false;
  }
  hideTooltip() {
    if (this.tooltipHidden) {
      return;
    }
    this.tooltipHidden = true;
  }
  positionTootip(event) {
    const target = event.target;
    const tooltipCoords = target.getBoundingClientRect();
    const displayRight = tooltipCoords.left - this.tooltipContent.offsetWidth * 1.5 < 0;
    const displayLeft = tooltipCoords.right + this.tooltipContent.offsetWidth * 1.5 > get(this.document, 'documentElement.clientWidth', document);
    const displayBottom = tooltipCoords.top - this.tooltipContent.offsetHeight * 1.5 < 0;
    if (!displayLeft) {
      this.setStyle('border-right-color');
      this.addClass('right');
      return;
    }
    if (!displayRight) {
      this.setStyle('border-left-color');
      this.addClass('left');
      return;
    }
    if (displayBottom) {
      this.setStyle('border-bottom-color');
      this.addClass('bottom');
      return;
    }
    if (!displayBottom) {
      this.setStyle('border-top-color');
      this.addClass('top');
      return;
    }
  }
  addClass(direction) {
    this.renderer.addClass(this.tooltipArrow, direction);
    this.renderer.addClass(this.tooltipContent, direction);
  }
  removeClass() {
    this.tooltipContent.className = 'tooltip-hidden';
    this.tooltipArrow.className = '';
  }
  setStyle(style) {
    this.removeStyle();
    if (this.bgColor && this.tooltipArrow) {
      this.renderer.setStyle(this.tooltipArrow, style, this.bgColor);
    }
  }
  removeStyle() {
    if (this.tooltipArrow) {
      this.renderer.removeAttribute(this.tooltipArrow, 'style');
    }
  }
  static {
    this.ɵfac = function TooltipComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TooltipComponent,
      selectors: [["upr-tooltip"]],
      viewQuery: function TooltipComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipBoxArrow = _t.first);
        }
      },
      inputs: {
        bgColor: "bgColor"
      },
      standalone: false,
      ngContentSelectors: _c3,
      decls: 8,
      vars: 7,
      consts: [["tooltipContainer", ""], ["tooltipBoxArrow", ""], ["id", "tooltip"], [1, "icon-container", 3, "mouseenter", "mouseleave"], ["id", "tooltip-container", 3, "ngClass", "ngStyle"], ["id", "tooltip-arrow", 3, "hidden"]],
      template: function TooltipComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
          i0.ɵɵlistener("mouseenter", function TooltipComponent_Template_div_mouseenter_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.displayTooltip($event));
          })("mouseleave", function TooltipComponent_Template_div_mouseleave_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.hideTooltip());
          });
          i0.ɵɵprojection(2, 0, ["role", "tooltip"]);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 4, 0);
          i0.ɵɵprojection(5, 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(6, "span", 5, 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c4, ctx.tooltipHidden))("ngStyle", i0.ɵɵpureFunction1(5, _c5, ctx.bgColor));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("hidden", ctx.tooltipHidden);
        }
      },
      dependencies: [i1.NgClass, i1.NgStyle],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}#tooltip[_ngcontent-%COMP%]{position:relative;display:inline-block}#tooltip[_ngcontent-%COMP%]   .icon-container[_ngcontent-%COMP%]{display:inline-block}@media print,screen and (min-width: 40em){#tooltip[_ngcontent-%COMP%]{top:4px}}#tooltip-arrow[_ngcontent-%COMP%]{border:8px solid transparent;pointer-events:none;position:absolute;min-height:10px;z-index:7}#tooltip-arrow.left[_ngcontent-%COMP%]{border-left-color:#036ce2;margin-top:5px;right:15px}#tooltip-arrow.right[_ngcontent-%COMP%]{border-right-color:#036ce2;left:25px;top:5px}#tooltip-arrow.top[_ngcontent-%COMP%]{border-top-color:#036ce2;bottom:18px;left:10px}#tooltip-arrow.bottom[_ngcontent-%COMP%]{border-bottom-color:#036ce2;top:13px;right:2px}#tooltip-container[_ngcontent-%COMP%]{font-weight:400;background:#036ce2;color:#fff;visibility:visible;font-size:14px;text-align:left;position:absolute;border-radius:5px;padding:10px 15px;z-index:7;max-width:240px;min-width:200px;height:max-content;-webkit-transition:visibility 0s,opacity .3s linear;-ms-transition:visibility 0s,opacity .3s linear;-o-transition:visibility 0s,opacity .3s linear;transition:visibility 0s,opacity .3s linear;opacity:1;filter:alpha(opacity=100)}#tooltip-container.top[_ngcontent-%COMP%]{right:-73px;bottom:33px}#tooltip-container.bottom[_ngcontent-%COMP%]{right:-73px;top:28px}#tooltip-container.left[_ngcontent-%COMP%]{right:30px;bottom:-42px}#tooltip-container.right[_ngcontent-%COMP%]{bottom:-42px;left:41px}#tooltip-container.tooltip-hidden[_ngcontent-%COMP%]{visibility:visible;left:-10000px;opacity:0;filter:alpha(opacity=0)}@media print,screen and (max-width: 63.99875em){#tooltip-container[_ngcontent-%COMP%]{width:200px}}.white-background[_nghost-%COMP%]   #tooltip-arrow.left[_ngcontent-%COMP%], .white-background   [_nghost-%COMP%]   #tooltip-arrow.left[_ngcontent-%COMP%]{border-left-color:#0368d9}.white-background[_nghost-%COMP%]   #tooltip-arrow.right[_ngcontent-%COMP%], .white-background   [_nghost-%COMP%]   #tooltip-arrow.right[_ngcontent-%COMP%]{border-right-color:#0368d9}.white-background[_nghost-%COMP%]   #tooltip-arrow.top[_ngcontent-%COMP%], .white-background   [_nghost-%COMP%]   #tooltip-arrow.top[_ngcontent-%COMP%]{border-top-color:#0368d9}.white-background[_nghost-%COMP%]   #tooltip-arrow.bottom[_ngcontent-%COMP%], .white-background   [_nghost-%COMP%]   #tooltip-arrow.bottom[_ngcontent-%COMP%]{border-bottom-color:#0368d9}.white-background[_nghost-%COMP%]   #tooltip-container[_ngcontent-%COMP%], .white-background   [_nghost-%COMP%]   #tooltip-container[_ngcontent-%COMP%]{background:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipComponent, [{
    type: Component,
    args: [{
      selector: 'upr-tooltip',
      standalone: false,
      template: "<div id=\"tooltip\">\r\n\t<div\r\n\t\tclass=\"icon-container\"\r\n\t\t(mouseenter)=\"displayTooltip($event)\"\r\n\t\t(mouseleave)=\"hideTooltip()\"\r\n\t>\r\n\t\t<ng-content select=\"[tooltip]\" role=\"tooltip\"> </ng-content>\r\n\t</div>\r\n\r\n\t<div\r\n\t\t[ngClass]=\"{ 'tooltip-hidden': tooltipHidden }\"\r\n\t\t#tooltipContainer\r\n\t\tid=\"tooltip-container\"\r\n\t\t[ngStyle]=\"{ 'background-color': bgColor }\"\r\n\t>\r\n\t\t<ng-content select=\"[tooltip-box]\"></ng-content>\r\n\t</div>\r\n\t<span [hidden]=\"tooltipHidden\" id=\"tooltip-arrow\" #tooltipBoxArrow> </span>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}#tooltip{position:relative;display:inline-block}#tooltip .icon-container{display:inline-block}@media print,screen and (min-width: 40em){#tooltip{top:4px}}#tooltip-arrow{border:8px solid transparent;pointer-events:none;position:absolute;min-height:10px;z-index:7}#tooltip-arrow.left{border-left-color:#036ce2;margin-top:5px;right:15px}#tooltip-arrow.right{border-right-color:#036ce2;left:25px;top:5px}#tooltip-arrow.top{border-top-color:#036ce2;bottom:18px;left:10px}#tooltip-arrow.bottom{border-bottom-color:#036ce2;top:13px;right:2px}#tooltip-container{font-weight:400;background:#036ce2;color:#fff;visibility:visible;font-size:14px;text-align:left;position:absolute;border-radius:5px;padding:10px 15px;z-index:7;max-width:240px;min-width:200px;height:max-content;-webkit-transition:visibility 0s,opacity .3s linear;-ms-transition:visibility 0s,opacity .3s linear;-o-transition:visibility 0s,opacity .3s linear;transition:visibility 0s,opacity .3s linear;opacity:1;filter:alpha(opacity=100)}#tooltip-container.top{right:-73px;bottom:33px}#tooltip-container.bottom{right:-73px;top:28px}#tooltip-container.left{right:30px;bottom:-42px}#tooltip-container.right{bottom:-42px;left:41px}#tooltip-container.tooltip-hidden{visibility:visible;left:-10000px;opacity:0;filter:alpha(opacity=0)}@media print,screen and (max-width: 63.99875em){#tooltip-container{width:200px}}:host-context(.white-background) #tooltip-arrow.left{border-left-color:#0368d9}:host-context(.white-background) #tooltip-arrow.right{border-right-color:#0368d9}:host-context(.white-background) #tooltip-arrow.top{border-top-color:#0368d9}:host-context(.white-background) #tooltip-arrow.bottom{border-bottom-color:#0368d9}:host-context(.white-background) #tooltip-container{background:#0368d9}\n"]
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], {
    bgColor: [{
      type: Input
    }],
    tooltipContainer: [{
      type: ViewChild,
      args: ['tooltipContainer', {
        static: true
      }]
    }],
    tooltipBoxArrow: [{
      type: ViewChild,
      args: ['tooltipBoxArrow', {
        static: true
      }]
    }]
  });
})();
class TooltipModule {
  static {
    this.ɵfac = function TooltipModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TooltipModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TooltipModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TooltipModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [TooltipComponent],
      exports: [TooltipComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of tooltip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TooltipComponent, TooltipModule };
